<template>
  <component
    :is="tagName"
    :class="$style.heading"
    :style="{
      marginBottom: `${marginBottom * 1}rem`
    }"
  >
    <slot />
  </component>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  props: {
    tagName: {
      type: String,
      default: 'span',
    },
    marginBottom: {
      type: Number,
      default: 0.75,
    },
  },
});
</script>

<style lang="scss" module>
@import '../styles/variables-entry';

.heading {
  display: block;
  margin-top: 0; // 1
  font-family: $headings-font-family;
  font-weight: $headings-font-weight;
  line-height: $headings-line-height;
  color: $headings-color;
}
</style>
